"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGetFilterBySport = exports.useFilterBySport = void 0;
const react_1 = require("react");
const selectors_1 = require("../../selectors");
const slice_1 = require("../../slice");
const hooks_1 = require("../../../../store/hooks");
const useFilterBySport = (listKey) => {
    const dispatch = (0, hooks_1.useAppDispatch)();
    const onChangeSport = (0, react_1.useCallback)(({ sportId }) => {
        dispatch(slice_1.eventsProviderActions.updateFilters({
            listKey,
            filters: {
                sportIds: [sportId],
            },
        }));
    }, [dispatch, listKey]);
    return { onChangeSport };
};
exports.useFilterBySport = useFilterBySport;
const useGetFilterBySport = (listKey) => {
    var _a;
    const filters = (0, hooks_1.useAppSelector)((state) => (0, selectors_1.getEventListFilters)(state, listKey));
    return ((_a = filters.sportIds) === null || _a === void 0 ? void 0 : _a[0]) || 0;
};
exports.useGetFilterBySport = useGetFilterBySport;
//# sourceMappingURL=useFilterBySport.js.map